import React from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useLocation } from 'react-router-dom'

import { ThemeButton } from '../../../../ui'

export const AddCampaignBtn = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { formatMessage } = useIntl()

  const handleNavigate = () => {
    navigate('/campaigns/new', {
      state: { prevSearch: location.search },
    })
  }

  return (
    <ThemeButton color="primary" onClick={handleNavigate}>
      {formatMessage({ id: 'pages.campaigns.button.new.label' })}
    </ThemeButton>
  )
}
